import type { Role } from '@travel-planner/shared/schemas/auth';
import { roles } from '@travel-planner/shared/schemas/auth';

const ROLE_LABELS: Record<Role, string> = {
  admin: 'Admin',
  operation: 'Operation',
  consulting: 'Consulting',
  external: 'External',
  content: 'Content',
  system: 'System',
  finance: 'Finance',
  super_finance: 'Super finance',
  marketing_admin: 'Marketing admin',
  hq_admin: 'HQ Admin',
  hq_finance_legal: 'HQ Finance/Legal',
  dmc_principal: 'DMC Principal',
  dmc_editor: 'DMC Editor',
  consortium_member: 'Consortium Member',
};

export const ROLE_OPTIONS = roles.map((role) => ({
  value: role,
  label: ROLE_LABELS[role],
}));

export const formatRoleLabel = (role: string): string =>
  ROLE_LABELS[role as Role] ?? role;
